import { Component, OnInit } from '@angular/core';
import { MasterService,InventoryService } from '../../services/index';

import { AppGlobals } from '../../shared/app.global';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.scss'],
  providers:[MasterService,InventoryService]
})
export class PurchaseComponent implements OnInit {

 closeResult: string;
  modalOptions:NgbModalOptions;
  modalOptions1:NgbModalOptions;
  private modalRef: NgbModalRef;
  classes:any=[];
  totalsum:any;
  arrfeedet:any=[];
  arrfeesumlist:any=[];
  castecats:any=[];
  subcomb:any=[];
  oprtype:string;
  oprtype1:string;
  filtcatgory:any[];
  arrinstallment:any=[];
  aylist:any[];
  arpayopt:any=[];
  arfeequota:any=[];
  armot:any=[];
  arrcourse:any=[];
  arracchead:any=[];
  objdetacc:any={};
  objdetmain:any={};
  accat:any=[];
  catid:any;
  arradmtype=['Received', 'Authorised', 'Cancel'];
  arrpstatus=['Pending', 'Paid', 'Partial'];
  arrinvmstore: any=[];
  arrsupl: any=[];
  arrvocdet: any=[];
  arritems: any=[];
  filteredCountries: any[];
  arrinvh: any=[];
  arrinvd: any=[];
  objdet: any;
  constructor(private iservice: InventoryService,private http: HttpClient, private fservice: MasterService,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.getinvh();
this.getinvmsplr();
    this.getinvmstore();
    this.getinvmitem();
    
  }

 filterCountry(event) {
  debugger
        let filtered: any[] = [];
        let query = event.query;
        
        for (let i = 0; i < (this.arritems as any[]).length; i++) {
            let country = (this.arritems as any[])[i];
            // if (country.itnm.toLowerCase().indexOf(query.toLowerCase()) == 0) {
             if (country.itnm.toLowerCase().includes(query.toLowerCase())) {
                filtered.push(country);
            }
        }
        this.filteredCountries = filtered;
    }
  addacchead()
{
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrvocdet.push({itid:'1',mrp:'0',prate:'0',pdisc:'0',pqty:'0',fqty:'0'});
console.log('arrvoc1',this.arrvocdet);



//$scope.payRows.push({});
}

remaddacchead(ind)
{
//alert(ind);
this.arrvocdet.splice(ind,1);
}

  getinvmstore() {
    this.iservice.getinvmstore()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvmstore = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

   getinvmsplr() {
    this.iservice.getinvmsplr()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrsupl = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

    getinvmitem() {
    this.iservice.getinvmitem()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arritems = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  openmdldetmain(content,objdata,cmd) {

    this.oprtype=cmd;
    if(cmd=='insert')
    {
      this.objdetmain.grnid='0';
      this.objdetmain.grndt=this.fservice.getdatetoday();
      this.objdetmain.invdt=this.fservice.getdatetoday();
      this.objdetmain.invno='';
      this.objdetmain.grnhsts='Received';
      this.objdetmain.paystatus='Paid';
      this.objdetmain.stid=this.arrinvmstore[0].stid;
      this.objdetmain.splid=this.arrsupl[0].splid;
      
     
     

    }

    else{
     this.objdetmain.oprtype="update";
    this.getinvgrn(objdata.grnid);
    // this.getacfeechartdetail(objdata);
    }
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  openmdldetacc(content,objdata,cmd) {
    
    this.oprtype1=cmd;
    this.objdetacc={}
    if(cmd=='insert')
    {
      this.objdetacc.acid='1';
      this.objdetacc.rid='0';
      this.objdetacc.feeamt='1';
    }

    else if(cmd=='update')
    {
      this.objdetacc=objdata;
    }
    //this.getacfeechartdetail(objdata);
    this.modalOptions1 = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions1);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  savefromdet() {
    this.objdetmain.acid=this.objdetacc.acid;
    this.objdetmain.feeamt=this.objdetacc.feeamt;
    this.objdetmain.rid=this.objdetacc.rid;
    this.objdetmain.oprtype=this.oprtype1;

    console.log('savedetails',this.objdetmain);

    this.fservice.saveacfeechart(this.objdetmain)
    .subscribe(result => {
      alert(result.message);
      
   if(result.status=='success')
   {
     let localmodref=this.modalRef;
   localmodref.close();
   //this.Refreshsummary();
  //  this.getacfeechartdetail(this.objdetmain);
   
   }
   
   
   else{
   
   
   }
      
   
     
       
   }, error => alert('error in connection')
   );
   
  } 


  delacc(rid) {
    
if(confirm('Are you sure, you want to delete ?'))
{
    this.fservice.delacfeechart(rid)
    .subscribe(result => {
      alert(result.message);
      
   
  //  this.getacfeechartdetail(this.objdetmain);
   
     
       
   }, error => alert('error in connection')
   );
   
  }
}

saveinvtisutmpd()
    {
  // console.log('catsave',this.itemmodel);
    // $istpid=$data['istpid'];
  // var pst={istpid:this.istpid,issuedtls:this.arrvocdet,oprtype:"insert"};

  const ownerCarMakes = this.arrvocdet.map(owner => {
  
  owner.itmid=owner.itid.itid;
  return owner;
});
console.log('ownerCarMakes',ownerCarMakes);
  var pst=this.objdetmain;
  pst.issuedtls=ownerCarMakes;
  pst.oprtype=this.oprtype;
    console.log('savetisutmpd',pst);
      this.iservice.saveinvtgrn(pst)
          .subscribe(
          result => {
              console.log('savelibcategory', result);
              //this.suppliers = resultArray;
              alert(result.message);
              if(result.status=='Success')
              {
                let localmodref=this.modalRef;
                localmodref.close();
                this.arrvocdet=[];
                this.objdetmain={};
                this.getinvh();
                // this.getinvtisutmpd(this.istpid);
                //this.getlibcategory();
  
              }
             else
             {
  
             }
          },
          error =>{ alert('Error While saving...');}
          )
    }

      getinvh() {
    this.iservice.getinvh()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvh = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


   getinvgrn(grnid) {
    this.iservice.getinvgrn(grnid)
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvd = resultArray.arrgrnd;
             this.objdetmain = resultArray.objgrnh;
           
        },
        error => console.log("Error :: " + error)
        )
  }


    openedit(content,objdata) {
      debugger
  this.objdet=objdata;
      // this.getinvtisutmpd(this.istpid);
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'sm'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }

  delgrnd(grnid,grid) {
    debugger
    if(confirm('Are you sure, you want to delete ?'))
{ 
    this.iservice.delgrnd(grid)
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
            if(resultArray.status=='Success')
            {
              alert(resultArray.message);
              this.getinvgrn(grnid);
            }
           
           
        },
        error => console.log("Error :: " + error)
        )
  }
}

savegrnd()
    {
  // console.log('catsave',this.itemmodel);
    // $istpid=$data['istpid'];
  // var pst={istpid:this.istpid,issuedtls:this.arrvocdet,oprtype:"insert"};

 
      this.iservice.updgrnd(this.objdet)
          .subscribe(
          result => {
              console.log('savelibcategory', result);
              //this.suppliers = resultArray;
              alert(result.message);
              if(result.status=='Success')
              {
                let localmodref=this.modalRef;
                localmodref.close();
                
               
                this.getinvgrn(this.objdet.grnid);
   this.objdet={};
              }
             else
             {
  
             }
          },
          error =>{ alert('Error While saving...');}
          )
    }
}

